import React, { useEffect, useState } from "react";
import Header from "./Header";
import SideBar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarExpanded((prev) => !prev);
  };

  useEffect(() => {
    if (isSidebarExpanded) {
      document.body.classList.add("sidebarMobileExpand");
    } else {
      document.body.classList.remove("sidebarMobileExpand");
    }
  }, [isSidebarExpanded]);

  return (
    <>
      <Header
        isSidebarExpanded={isSidebarExpanded}
        // setIsSidebarExpanded={setIsSidebarExpanded} 
        toggleSidebar={toggleSidebar}
      />
      <SideBar
        isSidebarExpanded={isSidebarExpanded}
        // setIsSidebarExpanded={setIsSidebarExpanded}
        toggleSidebar={toggleSidebar}
      />
      <div className={`${!isSidebarExpanded ? "pageWrapper" : "pageWrapperClose"}`} >
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;
